import React from "react"
import styled, { css } from "styled-components"

import Button from "../atoms/button"
import { Grid, Block } from "../atoms/layout-primitives"
import { TypeCard } from "../atoms/accent-cards"
import { T, Text } from "../atoms/text"

const TypeCardGrid = ({
  title,
  description,
  cardContents,
  showScrollButton = true,
}) => {
  return (
    <Grid>
      <Text
        as="h2"
        variants={[
          css`
            ${T.sm.h2`500`}
            grid-column: 1 / -1;
            text-align: left;
            color: var(--slate);
          `,
          css`
            text-align: center;
            ${T.md.h2`500`}
            grid-column: 2 / -2;
          `,
          css`
            ${T.lg.h2`500`}
          `,
        ]}
      >
        {title}
      </Text>
      <Text.Body
        variants={[
          css`
            grid-column: 1 / -1;
            text-align: left;
            margin-top: 24px;
            margin-bottom: 48px;
          `,
          css`
            text-align: center;
            grid-column: 2 / -2;
          `,
          css`
            grid-column: 3 / 11;
            margin-bottom: 64px;
          `,
        ]}
      >
        {description}
      </Text.Body>
      <Block
        display={{ sm: "grid" }}
        col={{ sm: "1 / -1", md: "2 / -2" }}
        variants={[
          css`
            grid-template-columns: 1fr;
            grid-gap: 32px;
          `,
          null,
          css`
            grid-template-columns: 1fr 1fr;
            grid-gap: 48px;
            align-items: start;
          `,
        ]}
      >
        {cardContents.map((cardContent) => (
          <TypeCard>
            <TypeCard.Logo src={cardContent.logo} alt="" />
            <TypeCard.Title>{cardContent.title}</TypeCard.Title>
            <TypeCard.Description>
              {cardContent.description}
            </TypeCard.Description>
          </TypeCard>
        ))}
      </Block>
      {showScrollButton && (
        <Button.ScrollLink
          to="contact-form"
          smooth
          duration={1000}
          variants={[
            css`
              grid-column: 1 / -1;
              margin: 32px auto 0 auto;
            `,
            null,
            css`
              margin-top: 48px;
            `,
          ]}
        >
          Book a Demo
        </Button.ScrollLink>
      )}
    </Grid>
  )
}

export default styled(TypeCardGrid)``
